import * as idb from 'idb';

const DATABASE_NAME = 'RockmetricDB';
const DATABASE_VERSION = 2;
const db = idb.default;
const dbName = ['SummaryData', 'ChartData', 'TableData', 'Total_TableData', 'DashboardFilters']

const dbPromise = db.open(DATABASE_NAME, DATABASE_VERSION, function(upgradeDb){
    /* tslint:disable */
    switch(upgradeDb.oldVersion){
        case 0:
            // a placeholder case so that the switch block will
            // execute when the database is first created
            // (oldVersion is 0)
        case 1:
            // First object Store for Summary Data
            dbName.forEach((e) => {
                var objectStore = upgradeDb.createObjectStore(e,{keyPath: 'key', autoIncrement : true});
                objectStore.createIndex('key', 'key', {unique: true})
                objectStore.createIndex('timestamp', 'timestamp', {unique: true})
            })
    }
})

export class DBService {

    //get function
    get(storeName ,key){
        return dbPromise.then(db => {
            return db.transaction(storeName).objectStore(storeName).get(key);
        }).catch(error => {
            console.log(error)
        })
    }

    //put function
    put(storeName, object, key){
        return dbPromise.then(db => {
            if (key){
                return db.transaction(storeName, "readwrite").objectStore(storeName).put({key:key,object:object,timestamp: new Date(Date.now() + (Math.random() - 0.5) * 10000)})
            }
            return db.transaction(storeName,"readwrite").objectStore(storeName).put({object:object});
        }).catch(error => {
            console.log(error)
        })
    }

    //delete function
    delete(storeName, key){
        return dbPromise.then(db => {
            return db.transaction(storeName, "readwrite").objectStore(storeName).delete(key);
        }).catch(error => {
            console.log(error)
        })
    }

    //delete all function
    deleteAll(storeName) {
        return dbPromise.then(db => {
          return db.transaction(storeName, 'readwrite').objectStore(storeName).clear();
        }).catch(error => {
          console.log(error)
        });
    }


    //delete using timestamp
    deleteByTimestamp(storeName, toolId) {
        const range = IDBKeyRange.upperBound(new Date((Date.now() - 604800000) + (Math.random() - 0.5) * 10000), true)
        let toolID = toolId;
        return dbPromise.then(db => {
            var transaction = db.transaction(storeName, 'readwrite');
            var store = transaction.objectStore(storeName);
            var index = store.index('timestamp');
            var request = index.openCursor(range);
            var request = index.getAll(range);
            request.request.onsuccess = function(e){
                let data = e.target.result;
                let dataKeys = [];
                data.forEach(i => {
                    if(JSON.parse(i.key).toolId === toolID){
                        dataKeys.push(i.key)
                    }
                })
                dataKeys.forEach(item => {
                    store.delete(item)
                }
                )
            };
        }).catch(error => {
            console.log(error)
        })
    }

    deleteByToolId(storeName, toolId){
        let toolID = toolId;
        return dbPromise.then(db => {
            var transaction = db.transaction(storeName, 'readwrite');
            var store = transaction.objectStore(storeName);
            var request = store.getAll();
            request.request.onsuccess = function(e){
                let data = e.target.result;
                let dataKeys = [];
                data.forEach(i => {
                    if (JSON.parse(i.key).toolId === toolID) {
                        dataKeys.push(i.key)
                    }
                })
                dataKeys.forEach(item => {
                    store.delete(item)
                })
            };
        }).catch(error => {
            console.log(error)
        })
    }
}
//604800000 = 1 week